import diarioApi from '../../api/diario';
import * as types from "../mutation-types";

// initial state
const state = {

};

// actions
const actions = {
  baixarPdfDiario({ commit }, payload) {
    return diarioApi.baixarPdfDiario(payload)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let filename = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename=['"](.*?)['"]/;
          const matches = filenameRegex.exec(disposition);
          if (matches !== null && matches[1]) {
            filename = matches[1];
          } else {
            filename = 'diario.pdf';
          }
        }
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      });
  }
};

export default {
  state,
  actions,
};
